export default {
  // Rochen
  0x00: {
    url: 'https://www.ideas-engineering.io/team-drei-rochen',
    description: "Möchtest du mehr über das Team 3 Rochen erfahren?"
  },
  // A Team
  0x01: {
    url: 'https://www.ideas-engineering.io/a-team',
    description: "Möchtest du mehr über das A-Team erfahren?"
  },
  // Team X
  0x02: {
    url: 'https://www.ideas-engineering.io/team-x',
    description: "Möchtest du mehr über das Team X erfahren?"
  },
  // Sheldons
  0x03: {
    url: 'https://www.ideas-engineering.io/team-sheldons',
    description: "Möchtest du mehr über das Team Sheldons erfahren?"
  },
  //Team AI
  0x04: {
    url: 'https://www.ideas-engineering.io/team-ai',
    description: "Möchtest du mehr über das Team AI erfahren?"
  },
  // Tailors
  0x05: {
    url: 'https://www.ideas-engineering.io/team-tailor',
    description: "Möchtest du mehr über die Tailors erfahren?"
  },
  //Mac Cheese
  0x06: {
    url: 'https://www.ideas-engineering.io/team-mac-cheese',
    description: "Möchtest du mehr über das Team Mac & Cheese erfahren?"
  },
  //Team UX
  0x07: {
    url: 'https://www.ideas-engineering.io/team-ux',
    description: "Möchtest du mehr über das Team UX erfahren?"
  },
  //Coaches
  0x08: {
    url: 'https://www.ideas-engineering.io/team-agile-coaches',
    description: "Möchtest du mehr über unsere Agile Coaches erfahren?"
  }
}